module.exports = __webpack_public_path__ + "static/img/夜游.88ca2353.png";